module.exports = __webpack_public_path__ + "static/media/20201121_224739_695_IMG_1077.9390272d.jpg";